import { render } from "./FeaturedProduct.vue?vue&type=template&id=5fcf68de&scoped=true"
import script from "./FeaturedProduct.vue?vue&type=script&lang=js"
export * from "./FeaturedProduct.vue?vue&type=script&lang=js"

import "./FeaturedProduct.vue?vue&type=style&index=0&id=5fcf68de&lang=scss&scoped=true"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcf68de"]])

export default __exports__